<script setup>

const config = useRuntimeConfig();
const { braindateUrl } = config.public;
const { loggedIn, user, clear: clearSession, fetch: refreshSession } = useUserSession()

onMounted(async () => {
    if (loggedIn.value && process.client && user.value.braindateHash) {
        await navigateTo(`${braindateUrl}/?ext-id=${user.value.braindateHash}&ext-token=${user.value.email}`, { external: true })
    }
})

</script>
<template>
    <div class="braindate-modal">
        <FragmentsSpinner />
        <h1 class="h2">Redirecting to Braindate...</h1>
        <p>Create, join and host 1-on-1 and group conversations at INBOUND.</p>
    </div>
</template>

<style lang="scss">
.braindate-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    height: 100%;
    color: var(--teal);

    svg {
        margin-bottom:  2.25rem;
    }

    .h2 {
        text-align: center;
        font-size: 2rem;
        font-weight: 500;
        line-height: 2.5rem; /* 125% */
        letter-spacing: -0.04rem;
        margin-bottom: 0.5rem;
    }

    p {
        text-align: center;
        font-size: 0.9375rem;
        font-weight: 300;
        line-height: 1.5625rem; /* 166.667% */
        letter-spacing: 0.01875rem;
    }
}
</style>